
import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import moment from "moment";
import InvoiceTable from "@/components/invoice/InvoiceTable.vue";
import GET_PROFILE_DETAILS from "@/apollo/profile/profileDetails/GetProfileDetail.gql";
import InvoiceSummary from "@/components/invoice/InvoiceForm/InvoiceSummary.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import { User_Profile, User } from "@/generated/graphql";
import GET_CONTRACTOR_DETAILS from "@/apollo/contractors/GetContractorBasicInfo.gql";
import GET_PROJECT_ACTIVITY from "@/apollo/projectActivities/GetProjectActivityByProjectId.gql";
import UiButton from "@/components/button/ui-button.vue";
import NoteModal from "@/views/invoice/NoteModalInvoice.vue"

@Component({
  components: {
    InvoiceTable,
    InvoiceSummary,
    LoadingOverlay,
    NoteModal,
    UiButton,
  },
})
export default class Step2 extends Vue {
  @Prop({ type: Object, default: () => ({}) }) record!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  selectedItems = [];
  contractor?: any = {};
  taskName: string = "";
  note = null;
  profile?: User_Profile = undefined;
  loading: boolean = false;
  allTimesheets = [];
  isDataLoaded = true; 
  isCheckboxChecked: boolean = false;
  activeTabIndex: number = 0;
  showNoteModal: boolean = false;

  handleCancel() {
    this.$router.replace("/invoice");
  }

  headers = [
    // { text: "Date", value: "date" },
    { text: "Visit", value: "visit" },
    { text: "Rate", value: "rate" },
    { text: "Hours", value: "hours" },
    { text: "Total amount", value: "totalAmount" },
     { text: "Status", value: "status", badge: true },
    { text: "Notes", value: "notes" },
   
  ];

  invoiceData = [];

  get hasData(): boolean {
    return (Boolean(this.contractor) || Boolean(this.profile));
  }
  get isLoaded() {
    if (
      this.$apollo &&
      this.$apollo.queries &&
      this.$apollo.queries.contractor &&
      this.$apollo.queries.profile
    ) {
      return (
        !this.$apollo.queries.contractor.loading &&
        !this.$apollo.queries.profile.loading
      );
    }
    return false;
  }
 handleNote(note) {

  const approvedTimes = this.allTimesheets
    .filter((item) => item.id === note.id);
    const getApprovedTime =  
    approvedTimes.map((time) => {
      const filteredActivities = time.project_activity_times.filter((activity) => {
        return activity.status === "APPROVED"; 
      });
      return filteredActivities; 
    });

  this.showNoteModal = true;
  this.taskName = note.task;
  this.note = getApprovedTime.flat(); 
}
  async created() {
    await this.$apollo
      .query({
        query: GET_PROJECT_ACTIVITY,
        variables: {
          where: {
            _and: {
              project_id: { _eq: this.record.project_id.id },
            },
          },
        },
        fetchPolicy: "network-only",
      })
      .then(({ data }) => {
        this.allTimesheets = data.project_activity;
        this.invoiceData = data.project_activity
          .filter((activity) =>
            activity.project_activity_times.some(
              (time) => time.status === "APPROVED" && time.invoice_id === null
            )
          )
          .map((activity) => {
            const approvedTimes = activity.project_activity_times.filter(
              (time) => time.status === "APPROVED"
            );
            const totalHours = this.calculateTotalHours(approvedTimes);
            const totalFormattedHours =
              this.formatedcalculateTotalHours(approvedTimes);
            const totalAmount = this.calculateTotalAmount(
              totalHours,
              this.record.rate
            );
            const getAllProjectActivityTimeID = activity.project_activity_times.map((item) => item.id);
            return {
              id: activity.id,
              acitivity_time_id: getAllProjectActivityTimeID,
              visit: this.formatDate(activity.start_date),
              // task: activity.title,
              hours: totalFormattedHours,
              totalAmount: `$${totalAmount.toFixed(2)}`,
              notes: activity.note,
              rate: this.record.rate,
              status: "APPROVED",
            };
          });
        this.selectedItems = this.invoiceData.filter(
          (item) => item.status === "APPROVED"
        );
      }).catch((error) => {});

    this.selectedItems = this.invoiceData.filter(
      (item) => item.status === "APPROVED"
    );
    if (this.$route.params.id) {
      if (
        this.record.project_id.id === this.record.selectedItems[0].project_id
      ) {
        this.invoiceData = this.record.selectedItems;
        this.selectedItems = this.record.selectedItems;
      }
    }
  }
 
  isEditMode() {
    return this.$route.query.action === "edit";
  }
  toggleCheckbox() {
    this.isCheckboxChecked = !(this.$refs.checkbox as any).checked;
  }
  handleCheckboxChange(event) {
    this.isCheckboxChecked = event.target.checked;
  }
  handleSelectionChange(newSelectedItems) {
    this.selectedItems = newSelectedItems;
  }
  handleContinue() {
    if (this.isEditMode()) {
      this.$router.replace({ query: {} });
      this.$emit("continue", { selectedItems: this.selectedItems }, 2);
    } else {
      this.$emit("continue", { selectedItems: this.selectedItems });
    }
  }
  calculateTotalHours(approvedTimes) {
    return approvedTimes.reduce((sum, time) => sum + time.time, 0) / 3600;
  }
  formatedcalculateTotalHours(approvedTimes) {
    const totalSeconds = approvedTimes.reduce(
      (sum, time) => sum + time.time,
      0
    );
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }

  calculateTotalAmount(hours, budget) {
    if(budget !== 'n/a') {
      return hours * budget;
    }
    else{
      return 0;
    }
  }

  formatDate(dateString) {
    return moment(dateString).format("MMM D, YYYY");
  }

  hiddenMessage: boolean = true;
  handleMessage() {
    this.hiddenMessage = false;
  }

  // This JavaScript code adds the 'safari' class to the body element when the browser is Safari.
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if(isSafari) {
    document.body.classList.add("safari");
  }
}
